import { Injectable } from "@angular/core";
import {
  PRIMITIVE,
  ClientMessageBrokerFactory,
  ClientMessageBroker,
  FnArg,
  UiArguments,
} from "shared/provider-webworker";

import { AccountLookupService } from "./AccountLookupService";
import { ReplicaLookupService } from "../../impl/ReplicaLookupService";
import { IRateSourcePromiseLookupService } from "../IRateSourcePromiseLookupService";
import { BaseLookupService } from "../../impl/BaseLookupService";
import { PromiseLookupService } from "../../impl/PromiseLookupService";
import { RateSourceLookupService } from "./RateSourceLookupService";

import * as CubiqTS from "shared/cubiq-model-multi-asset";
import { LoggerService } from "@bfx/logger";
const logger = LoggerService.for(__dirname);

@Injectable()
export class RateSourceReplicaLookupService
  extends ReplicaLookupService<string, CubiqTS.RateSourceImpl>
  implements IRateSourcePromiseLookupService
{
  constructor(protected factory: ClientMessageBrokerFactory) {
    super(
      factory,
      CubiqTS.RateSourceImpl,
      "RateSourceImpl",
      CubiqTS.ModelUpdateImpl,
      true,
      new RateSourceLookupService(),
    );
  }

  getRateSource(id: string): Promise<CubiqTS.RateSourceImpl> {
    let request = new UiArguments("getRateSource");
    let arg1 = new FnArg(id, PRIMITIVE);
    request.args = [arg1];
    return this.broker.runOnService(request, this.VALUE);
  }
}
